import { CheckCircleIcon, CloseIcon, ErrorIcon, InfoIcon, WarningIcon } from '@40seas/frontend/common/icons';
import { alpha, IconButton, Stack, Typography } from '@mui/material';
import { ChipColor, ChipProps } from './types';

export const Chip = ({ label, color = 'primary', variant = 'filled', onDelete, maxWidth, withIcon }: ChipProps) => {
    const isFilled = variant === 'filled';

    const IconComponent = withIcon ? iconComponentProvider(color) : undefined;

    return (
        <Stack
            direction="row"
            spacing={0.4}
            alignItems="center"
            justifyContent="center"
            bgcolor={`${isFilled ? color : 'background'}.light`}
            border={isFilled ? 'none' : '1px solid'}
            borderColor={`${color}.main`}
            boxSizing="border-box"
            width="fit-content"
            borderRadius={1}
            height={22}
            p={0.5}
        >
            {IconComponent}
            <Typography
                fontSize="12px"
                fontWeight="500"
                lineHeight={1}
                color={`${color}.main`}
                maxWidth={maxWidth}
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
            >
                {label}
            </Typography>
            {onDelete && (
                <IconButton
                    sx={{ bgcolor: (theme) => alpha(theme.palette[color]['main'], 0.12), lineHeight: 0, width: 12, height: 12 }}
                    onClick={onDelete}
                >
                    <CloseIcon size="tiny" color={`${color}.main` as any} />
                </IconButton>
            )}
        </Stack>
    );
};

const iconComponentProvider = (color: ChipColor) => {
    const defaultIconsMap = {
        info: InfoIcon,
        success: CheckCircleIcon,
        warning: WarningIcon,
        error: ErrorIcon,
    };

    const IconComponent = defaultIconsMap[color];

    if (!IconComponent) {
        return undefined;
    }

    return <IconComponent color={color} size="small" />;
};

export default Chip;
